import React, { useState, useEffect, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { LoadingOutlined } from '@ant-design/icons';
import './style.scss';

const HelpDesk = () => {
  const [helpdeskLoaded, setHelpdeskLoaded] = useState(false);
  return (
    <div className="help-desk__wrapper">
      <iframe src="https://help.procuzy.com/" onLoad={() => setHelpdeskLoaded(true)} />
      {!helpdeskLoaded && (
        <div className="help-desk__loader">
          <LoadingOutlined />
        </div>
      )}
    </div>
  );
};

const mapStateToProps = ({}) => ({
});

const mapDispatchToProps = (dispatch) => ({
});

HelpDesk.propTypes = {
  isRunning: PropTypes.bool,
  timeElapsed: PropTypes.any,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(HelpDesk));
